var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketingFields01 = function SvgMarketingFields01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "marketing_fields-01_svg2__a",
    x1: -5.52,
    x2: 153.42,
    y1: 162.19,
    y2: 3.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#marketing_fields-01_svg2__a",
    id: "marketing_fields-01_svg2__b",
    x1: -5.52,
    x2: 153.42,
    y1: 162.19,
    y2: 3.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#marketing_fields-01_svg2__a",
    id: "marketing_fields-01_svg2__c",
    x1: 33.79,
    x2: 192.6,
    y1: 201.51,
    y2: 42.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#marketing_fields-01_svg2__a",
    id: "marketing_fields-01_svg2__d",
    x1: 16.16,
    x2: 175.11,
    y1: 183.88,
    y2: 24.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#marketing_fields-01_svg2__a",
    id: "marketing_fields-01_svg2__e",
    x1: 51.16,
    x2: 210.11,
    y1: 218.88,
    y2: 59.94
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 66.68c-18.41 0-33.33 14.92-33.33 33.33s14.92 33.33 33.33 33.33S90 118.42 90 100.01c-.02-18.4-14.93-33.31-33.33-33.33m0 59.99C41.94 126.67 30 114.73 30 100s11.94-26.67 26.67-26.67S83.34 85.27 83.34 100c-.02 14.72-11.95 26.65-26.67 26.67",
    style: {
      fill: "url(#marketing_fields-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 80.01c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20c0-11.04-8.96-19.99-20-20m0 33.32c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33S70 92.64 70 100s-5.97 13.33-13.33 13.33",
    style: {
      fill: "url(#marketing_fields-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 130h40c5.52 0 10-4.48 10-10V80c0-5.52-4.48-10-10-10h-40c-5.52 0-10 4.48-10 10v16.67h-10v-60c0-1.84 1.49-3.33 3.33-3.33H140v16.67c0 5.52 4.48 10 10 10h-.01 40c5.52 0 10-4.48 10-10v-40c0-5.52-4.48-10.01-10-10.01h-40c-5.52 0-10 4.48-10 10v16.67h-6.67c-5.52 0-10 4.48-10 10v60h-10.15c-.03-.51-.02-1.02-.06-1.53a6.43 6.43 0 0 0-4.04-5.37l-7.05-2.82c-.98-3.41-2.34-6.7-4.07-9.8l3-7a6.4 6.4 0 0 0-.94-6.67 55.727 55.727 0 0 0-6.87-6.87 6.4 6.4 0 0 0-6.65-.93l-7 3c-3.1-1.72-6.39-3.09-9.8-4.07l-2.82-7.05a6.41 6.41 0 0 0-5.36-4.04c-3.23-.29-6.49-.29-9.72 0a6.43 6.43 0 0 0-5.37 4.04l-2.82 7.05c-3.41.98-6.7 2.34-9.8 4.07l-7-3a6.38 6.38 0 0 0-6.67.94 55.727 55.727 0 0 0-6.87 6.87 6.4 6.4 0 0 0-.93 6.65l3 7c-1.72 3.1-3.09 6.39-4.07 9.8l-7.05 2.82A6.41 6.41 0 0 0 .2 95.13a56 56 0 0 0 0 9.72 6.43 6.43 0 0 0 4.04 5.37l7.05 2.82c.98 3.41 2.34 6.7 4.07 9.8l-3 7a6.4 6.4 0 0 0 .94 6.67 55.727 55.727 0 0 0 6.87 6.87 6.4 6.4 0 0 0 6.65.93l7-3c3.1 1.72 6.39 3.09 9.8 4.07l2.82 7.05a6.41 6.41 0 0 0 5.36 4.04 56 56 0 0 0 9.72 0 6.43 6.43 0 0 0 5.37-4.04l2.82-7.05c3.41-.98 6.7-2.34 9.8-4.07l7 3a6.4 6.4 0 0 0 6.67-.94c1.23-1.03 2.43-2.13 3.58-3.28s2.25-2.33 3.29-3.59c1.54-1.86 1.9-4.43.93-6.65l-3-7c1.72-3.1 3.09-6.39 4.07-9.8l7.05-2.82a6.41 6.41 0 0 0 4.04-5.36c.04-.51.03-1.02.06-1.53h10.13v59.98c0 5.52 4.48 10 10 10H140v16.67c0 5.52 4.48 10 10 10h40c5.52 0 10-4.48 10-10v-40c0-5.52-4.48-10-10-10h-40c-5.52 0-10 4.48-10 10v16.67h-6.67c-1.84 0-3.33-1.49-3.33-3.33v-60h10V120c0 5.52 4.48 10 10 10m-3.34-49.99c0-1.84 1.49-3.33 3.33-3.33h40c1.84 0 3.33 1.49 3.33 3.33v40c0 1.84-1.49 3.33-3.33 3.33h-40c-1.84 0-3.33-1.49-3.33-3.33zm0-70c0-1.84 1.49-3.33 3.33-3.33h40c1.84 0 3.33 1.49 3.33 3.33v40c0 1.84-1.49 3.33-3.33 3.33h-40c-1.84 0-3.33-1.49-3.33-3.33zm-40.17 94.07-8.5 3.39c-1 .4-1.74 1.25-2 2.29-.97 3.92-2.53 7.67-4.62 11.13-.56.92-.64 2.05-.21 3.04l3.73 8.27c-.91 1.08-1.88 2.13-2.89 3.14s-2.06 1.98-2.9 2.81l-8.52-3.67c-.99-.42-2.12-.34-3.04.21-3.45 2.09-7.2 3.64-11.12 4.62-1.04.26-1.9 1-2.29 2l-3.22 8.47c-2.81.26-5.92.13-8.29.12l-3.44-8.59c-.4-1-1.25-1.74-2.29-2-3.92-.97-7.67-2.53-11.13-4.62-.92-.56-2.05-.64-3.04-.21l-8.27 3.74c-1.08-.91-2.13-1.88-3.14-2.89s-1.98-2.06-2.81-2.9l3.67-8.52c.42-.99.34-2.12-.21-3.04a40.2 40.2 0 0 1-4.62-11.13c-.26-1.04-1-1.9-2-2.29l-8.47-3.22c-.14-1.41-.2-2.83-.2-4.26s.06-2.85.06-4.04l8.6-3.44c1-.4 1.74-1.25 2-2.29.97-3.92 2.53-7.67 4.62-11.13.56-.92.64-2.05.21-3.04l-3.74-8.27c.91-1.08 1.88-2.13 2.89-3.14s2.06-1.98 2.9-2.81l8.52 3.67c.99.42 2.12.34 3.04-.21 3.46-2.09 7.21-3.65 11.13-4.62 1.04-.26 1.9-1 2.29-2l3.22-8.47c2.81-.26 5.92-.13 8.29-.12l3.44 8.59c.4 1 1.25 1.74 2.29 2 3.92.97 7.67 2.53 11.13 4.62.92.56 2.05.64 3.04.21l8.27-3.73c1.08.91 2.13 1.88 3.14 2.89s1.98 2.06 2.81 2.9l-3.67 8.52c-.42.99-.34 2.12.21 3.04 2.09 3.45 3.64 7.2 4.62 11.12.26 1.04 1 1.9 2 2.29l8.47 3.22c.13 1.41.19 2.83.19 4.26.01 1.36-.04 2.73-.16 4.08h.01ZM146.66 150c0-1.84 1.49-3.33 3.33-3.33h40c1.84 0 3.33 1.49 3.33 3.33v40c0 1.84-1.49 3.33-3.33 3.33h-40c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#marketing_fields-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.31 42.37c.62.62 1.47.98 2.36.98.11 0 .22 0 .33-.02.99-.1 1.89-.64 2.44-1.47l13.33-20a3.332 3.332 0 0 0-5.54-3.7l-11.08 16.62-3.79-3.79a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67Z",
    style: {
      fill: "url(#marketing_fields-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3 112.36c.62.63 1.47.98 2.36.98.11 0 .22 0 .33-.02.99-.1 1.89-.64 2.44-1.47l13.33-20a3.332 3.332 0 0 0-5.54-3.7l-11.08 16.62-3.79-3.79a3.332 3.332 0 0 0-4.71 4.71z",
    style: {
      fill: "url(#marketing_fields-01_svg2__e)"
    }
  }));
};
export default SvgMarketingFields01;